import { useEffect, useRef, useState } from "react";
// https://stackoverflow.com/a/61472427
export const useLazySvgImport = (name: string) => {
  const importRef = useRef<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        importRef.current = (
          // await import(`../assets/ISO/ISO_7000_-_Ref-No_${name}.svg?react`) doesnt work
          (await import(`../assets/ISO/${name}.svg`))
        ).default;
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);
  return {
    error,
    loading,
    Svg: importRef.current,
  };
};
